<template>
  <v-dialog v-model="dialog" max-width="750" persistent transition="dialog-bottom-transition" scrollable>
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat dark color="secondary">
          <v-toolbar-title>Informasi Detail Akses</v-toolbar-title>
          <v-spacer />
          <v-btn right icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pb-0 black--text">
        <v-alert v-if="akses" outlined color="secondary" dense class="mb-0 mt-3">
          <span class="black--text subtitle-1 font-weight-medium">{{ akses }}</span>
        </v-alert>
        <template>
          <v-list v-if="perans.length > 0" dense>
            <v-list-item v-for="(peran, id) in perans" :key="id">
              <v-list-item-action-text class="mr-1 subtitle-2 black--text font-weight-medium">
                ({{ peran.k_group }})
              </v-list-item-action-text>
              <v-list-item-content :class="[groups[peran.k_group] ? 'black--text' : 'red--text']">
                {{ groups[peran.k_group] ? groups[peran.k_group]['keterangan'] : 'Peran di luar lingkup Program' }}
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <div v-else class="font-italic grey--text my-2"> Tidak ada peran yang diset untuk akses di atas </div>
        </template>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div class="text-right">
          <v-btn color="secondary" right @click="close">OK</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PopupDetailAkses',
  props: {
    akses: {
      type: String,
      default: '',
    },
    perans: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
